module.exports = __webpack_public_path__ + "static/5- Panneau de controls Fx StartUp-420dda2584aa1a5507dd9e12a45cf00b.mp3";